import axios from 'axios';
import formatParams from 'jquery-param';

export default {
  fetchProcedureDirectoryList({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);

    return axios.get(`/procedureDirectory?${formatParams(params)}`)
      .then((procedureDirectories) => {
        commit('setData', procedureDirectories);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  downloadReport(_, id) {
    console.log(`params: ${id}`);

    return axios.get(`/procedureDirectory/report/${id}`, {
      responseType: 'blob',
      timeout: 30000,
    });
  },
};
